import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { mapAuthError, signIn } from '../../lib/partnerAuth';
import { trackEvent, WEB_PARTNER_LOGIN } from '../../lib/analytics';
import { usePageAnalytics } from '../../hooks/usePageAnalytics';
import { useSEO } from '../../hooks/useSEO';
import styles from './Auth.module.css';
import logo from '../../assets/images/logo.png';
import { PartnerAffiliatePromoStrip } from '../../components/partners/PartnerAffiliatePromoStrip';
import { PartnerHowItWorks } from '../../components/partners/PartnerHowItWorks';

export function PartnerLogin() {
  usePageAnalytics();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useSEO({
    title: 'Partner Login — LuvLust',
    description:
      'Earn $0.10 per credited app install from your referral links. Sign in to your LuvLust partner dashboard.',
  });

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn(email, password);
      void trackEvent(WEB_PARTNER_LOGIN);
      navigate('/partners/dashboard');
    } catch (err: unknown) {
      setError(mapAuthError(err, 'Login failed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.page}>
      <PartnerAffiliatePromoStrip />
      <div className={styles.pageBody}>
        <div className={styles.pageLayout}>
          <div className={styles.card}>
          <div className={styles.logoRow}>
            <img src={logo} alt="" width={36} height={36} />
            <span className={styles.brand}>LuvLust Partners</span>
          </div>
          <h1 className={styles.title}>Sign in to your dashboard</h1>

          {error && <div className={styles.error}>{error}</div>}

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <div className={styles.field}>
              <label htmlFor="password">Password</label>
              <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password" />
            </div>
            <p className={styles.forgotLink}>
              <Link to="/partners/forgot-password">Forgot password?</Link>
            </p>
            <button type="submit" className={styles.submit} disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p className={styles.switch}>
            Don't have an account? <Link to="/partners/signup">Sign up</Link>
          </p>
        </div>
          <PartnerHowItWorks />
        </div>
      </div>
    </div>
  );
}
